import React, { useEffect, useState } from 'react';
import { useBlocker } from 'react-router-dom';
import ConfirmModal from '@/components/ui/ConfirmModal';
import {
  consumeDirtyNavigationApproval,
  discardWorkspaceDirtyChanges,
  getWorkspaceDirtyLabels,
  setWorkspaceDirtyLabels,
  subscribeWorkspaceDirtyLabels,
} from './workspaceDirtyRegistry';

export const DirtyNavigationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [labels, setLabels] = useState(getWorkspaceDirtyLabels);
  useEffect(() => subscribeWorkspaceDirtyLabels(() => setLabels(getWorkspaceDirtyLabels())), []);
  useEffect(() => {
    if (!labels.length) return undefined;
    const warn = (event: BeforeUnloadEvent) => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [labels.length]);
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (consumeDirtyNavigationApproval()) return false;
    return labels.length > 0 && `${currentLocation.pathname}${currentLocation.search}${currentLocation.hash}` !== `${nextLocation.pathname}${nextLocation.search}${nextLocation.hash}`;
  });
  useEffect(() => () => setWorkspaceDirtyLabels('forms', []), []);
  return <>
    {children}
    <ConfirmModal isOpen={blocker.state === 'blocked'} title="Discard unsaved changes?" message={`Your unsaved ${labels.join(', ')} will be lost.`} confirmLabel="Discard and continue" cancelLabel="Keep editing" tone="danger" onClose={() => blocker.state === 'blocked' && blocker.reset()} onConfirm={() => { if (blocker.state !== 'blocked') return; discardWorkspaceDirtyChanges(); blocker.proceed(); }} />
  </>;
};

export const useGlobalDirtyGuard = (key: string, dirty: boolean, label: string): void => {
  useEffect(() => {
    setWorkspaceDirtyLabels(`form:${key}`, dirty ? [label] : []);
    return () => setWorkspaceDirtyLabels(`form:${key}`, []);
  }, [dirty, key, label]);
};
